
import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import stockmarketforbiginner from '../../images/cardpageimages/basicimages/stockmarketforbeginnerimage.jpg'
import IntroVideos from "../../componants/introvideos";
import StockMarketForBeginnersModules from "../../componants/allCourseModule/basicCourseModule/StockMarketForBeginnersModule";
function StockMarketForBiginners() {

  return (<>
    <Header />
    <BannerForAll
      text="Our Stock Market for Beginners course is designed to help newcomers understand the fundamentals of the stock market. Covering essential topics like how stocks work, trading basics, market trends, and risk management, this course provides the groundwork needed to start investing with confidence. Perfect for beginners aiming to make informed decisions in the stock market."
      title="STOCK MARKET FOR BEGINNER'S"
      imageone={stockmarketforbiginner}
      imagetwo={stockmarketforbiginner}
    />
    <IntroVideos
      vone=""
      vtwo=""
      topic=""
    />
    <StockMarketForBeginnersModules/>
    <Footer />
  </>)
}

export default StockMarketForBiginners;